<template>
  <p class="db-funnel-error db-text-center">
    <span class="db-bold db-funnel-error-title db-title-4">
      <slot name="title" />
    </span>
    <span class="db-funnel-error-message">
      <slot name="message" />
    </span>
    <span
      v-if="$slots.buttons"
      class="db-funnel-error-buttons"
    >
      <slot name="buttons" />
    </span>
  </p>
</template>

<style scoped>
.db-app .db-funnel-error {
  display: grid;
  align-content: start;
  justify-items: center;
  gap: var(--db-spacer-20);
  min-height: 40vh;
  padding-top: var(--db-spacer-24);
}

.db-app .db-funnel-error-title,
.db-app .db-funnel-error-message {
  line-height: var(--db-line-height-large);
}

.db-app .db-funnel-error-buttons {
  margin-top: var(--db-spacer-4);
}

@media screen and (min-width: 992px) {
  .db-app .db-funnel-error {
    padding-top: var(--db-spacer-64);
  }

  .db-app .db-funnel-error-buttons {
    margin-top: var(--db-spacer-20);
  }
}
</style>
